import { useTracking } from 'react-tracking';

import { Grid, Heading, Text, Button } from '@simplywallst/ui-core';

import {
  FeedCardLink,
  FeedCardItem,
  NarrativeFeedCard,
} from '@/components/FeedCard';
import type useCompanyFeed from '@/hooks/useCompanyFeed';

import { StyledCompanyFeed } from './styled';

type Company = NonNullable<ReturnType<typeof useCompanyFeed>['data']>;

interface Props {
  selectTab: (tab: 'updates') => void;
  company: Company;
  feedItem: Company['feedItems'][number];
}

export const ImportantUpdates = ({ company, selectTab, feedItem }: Props) => {
  const { trackEvent } = useTracking();

  return (
    <>
      <Grid
        templateColumns="max-content max-content"
        justifyContent="space-between"
        alignItems="center"
        data-cy-id="important-updates-header"
      >
        <Heading
          as="h3"
          typography="tinyStrong"
          color="whiteRGBA"
          opacity={0.5}
        >
          Important Updates
        </Heading>
        <Button
          styleType="softLinkReverse"
          onClick={() => {
            selectTab('updates');
            trackEvent({
              action: 'click',
              modifier: 'view-all-updates',
            });
          }}
        >
          <Text as="span" color="brand01" typography="xSmall">
            View All
          </Text>
        </Button>
      </Grid>
      <StyledCompanyFeed>
        {feedItem.type === 'narrative' ? (
          <NarrativeFeedCard
            company={company}
            feedItem={feedItem}
            index={0}
            key={`0-${feedItem.date}-${feedItem.url}`}
          />
        ) : (
          <FeedCardLink index={0} company={company} feedItem={feedItem}>
            <FeedCardItem hoverBackground="spaceGray" feedItem={feedItem} />
          </FeedCardLink>
        )}
      </StyledCompanyFeed>
    </>
  );
};
